import { combineReducers } from 'redux';
import paymentMethods from './paymentMethods.reducer';
import currencies from './currencies/currencies.reducer';
import taxgroups from './taxgroups/taxgroups.reducer';
import bookingGroups from './bookingGroups/bookingGroups.reducer';

const paymentReducers = combineReducers({
  paymentMethods,
  currencies,
  taxgroups,
  bookingGroups,
});

export default paymentReducers;
